import { createAction, props } from '@ngrx/store';
import {
  PagedPostedAircraftTripAudit,
  PostedAircraftTripSkeleton
} from '../../+models/trip-manager-audit.model';

export enum TripManagerActionTypes {}

export const ResetTripManager = createAction('[Trip Manager] Reset');

export const LoadPostedAircraftTripSkeletons = createAction(
  '[Trip Manager] Load PostedAircraftTrip Skeletons'
);

export const PostedAircraftTripSkeletonsLoaded = createAction(
  '[Trip Manager] PostedAircraftTrip Skeletons Loaded',
  props<{ payload: PostedAircraftTripSkeleton[] }>()
);

export const PostedAircraftTripSkeletonsLoadError = createAction(
  '[Trip Manager] PostedAircraftTrip Skeletons Load Error',
  props<{ err: any }>()
);

export const LoadPostedAircraftTripAudit = createAction(
  '[Trip Manager] Load PostedAircraftTrip Audit',
  props<{ postedAircraftTripId: number }>()
);

export const LoadNextPagePostedAircraftTripAudit = createAction(
  '[Trip Manager] Load NextPage PostedAircraftTrip Audit',
  props<{ postedAircraftTripId: number }>()
);

export const PostedAircraftTripAuditLoaded = createAction(
  '[Trip Manager] PostedAircraftTrip Audit Loaded',
  props<{
    postedAircraftTripId: number;
    audits: PagedPostedAircraftTripAudit;
  }>()
);

export const PostedAircraftTripAuditLoadError = createAction(
  '[Trip Manager] PostedAircraftTrip Audit Load Error',
  props<{ err: any }>()
);

export const LoadPostedAircraftTripLegAudit = createAction(
  '[Trip Manager] Load PostedAircraftTripLeg Audit',
  props<{ postedAircraftTripId: number; postedFlightId: number }>()
);

export const LoadNextPagePostedAircraftTripLegAudit = createAction(
  '[Trip Manager] Load NextPage PostedAircraftTripLeg Audit',
  props<{ postedAircraftTripId: number; postedFlightId: number }>()
);

export const PostedAircraftTripLegAuditLoaded = createAction(
  '[Trip Manager] PostedAircraftTripLeg Audit Loaded',
  props<{
    postedAircraftTripId: number;
    postedFlightId: number;
    audits: PagedPostedAircraftTripAudit;
  }>()
);

export const PostedAircraftTripLegAuditLoadError = createAction(
  '[Trip Manager] PostedAircraftTripLeg Audit Load Error',
  props<{ err: any }>()
);
